import React, { useState, useCallback, useContext, useEffect } from 'react';
import { Box, Typography, Button, SvgIcon } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import useStyles from './PanelHeader.styles';
import { IProfile } from '../../types/interfaces/IProfile';
import { Link } from 'react-router-dom';
import { EPaths } from '../../types/enums/EPaths';
import { endpoints } from '../../utils/endpoints';
import RedbullIcon from '../../assets/images/redbullIcon/RedbullIcon';
import { useTranslation } from 'react-i18next';
import useApi from '../../utils/useApi';
import tPaths from '../../utils/tPaths';
import usePermissionsStatus from '../../utils/usePermissionsStatus';
import { SessionContext } from '../../contexts/session/SessionContext';

const PanelHeader = () => {
  const styles = useStyles();
  const [isDrpActive, setIsDrpActive] = useState(false);
  const toggleIsDrpActive = useCallback(() => setIsDrpActive((cv) => !cv), []);
  const { t } = useTranslation();

  const { updateToken, token, setPermissions } = useContext(SessionContext);
  const { arrayToPermissions } = usePermissionsStatus();

  const { data, post } = useApi<IProfile>(token ? endpoints.profile : null);

  const handleOnClickLogout = useCallback(async () => {
    try {
      await post({ endpoint: endpoints.logOut });
      updateToken();
    } catch (e) {}
  }, [post, updateToken]);

  useEffect(() => {
    if (data) {
      setPermissions(arrayToPermissions(data.permissions));
    }
  }, [arrayToPermissions, data, setPermissions]);

  return (
    <Box className={styles.container}>
      <span className={styles.rbIconMargin}>
        <SvgIcon component={RedbullIcon} className={styles.rbIcon} />
      </span>
      <Button
        variant="text"
        endIcon={<ArrowDropDownIcon className={styles.icon} />}
        onMouseEnter={toggleIsDrpActive}
        onMouseLeave={toggleIsDrpActive}
        className={styles.dropdown}
      >
        <Typography variant="subtitle1">{data?.nameSurname}</Typography>
        {isDrpActive && (
          <Box className={styles.dropdownContent}>
            <Box className={styles.dropdownItem}>
              <Link className={styles.dropdownLinks} to={EPaths.MyProfile}>
                {t(tPaths.header.myProfile)}
              </Link>
            </Box>
            <Box className={styles.separatorLine} />
            <Box className={styles.dropdownItem}>
              <Link className={styles.dropdownLinks} onClick={handleOnClickLogout} to={''}>
                {t(tPaths.header.logOut)}
              </Link>
            </Box>
          </Box>
        )}
      </Button>
    </Box>
  );
};

export default PanelHeader;
